import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.media || initialState;

export const select = createSelector([selectSlice], state => state);

export const selectUploadedFile = createSelector(
  [selectSlice],
  state => state.uploadedFile,
);
